// extracted by mini-css-extract-plugin
export default {"cheeseContainer":"cheeseCounter_cheeseContainer__Amfki"};